<template>
  <div class="phone-page">
    <div class="title">修改手机号</div>
    <div class="phone-content">
      <div class="form-content">
        <el-form ref="form" :rules="rules" :model="form" label-width="150px">
          <el-form-item prop="mobile" label="原手机号">
            <el-input maxlength="11" v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item class="verification" prop="code" label="验证码">
            <el-input v-model="form.code"></el-input>
            <button class="btn-code" @click="isMobileUsed" v-if="getCodeBtn">获取验证码</button>
            <button class="btn-timer" v-else>{{ second }}秒</button>
          </el-form-item>
          <el-form-item prop="newMobile" label="新手机号">
            <el-input v-model="form.newMobile"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="border-radius:0" type="primary" @click="submitForm('form')">提交</el-button>
            <el-button style="border-radius:0">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
export default {
  data() {
    return {
      second: 60,
      getCodeBtn: true,
      form: {
        mobile: '',
        code: '',
        newMobile: ''
      },
      rules: {
        mobile: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(Error('手机号码不能为空'));
              } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(Error('请输入正确的手机号'));
              } else {
                callback();
              }
            },
            required: true,
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 6, message: '长度在 4 到 6 个字符', trigger: 'blur' }
        ],
        newMobile: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(Error('手机号码不能为空'));
              } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(Error('请输入正确的手机号'));
              } else {
                callback();
              }
            },
            required: true,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    // 判断手机号码是否可用
    async isMobileUsed() {
      if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        this.$message('手机号码格式不正确');
        return;
      }
      this.sendCode();
    },
    // 发送验证码
    async sendCode() {
      const res = await api.login.getVerifyCode({
        mobile: this.form.mobile
      });
      if (res) {
        this.$message.success('验证码发送成功');
        this.getCodeBtn = false;
        let timer = setInterval(() => {
          if (this.second === 1) {
            clearInterval(timer);
            this.getCodeBtn = true;
            this.second = 60;
          }
          this.second--;
        }, 1000);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          api.login.bindMobile({
            mobile: this.form.mobile,
            new_mobile: this.form.newMobile,
            code: this.form.code
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.phone-page {
  min-height: 539px;
  background-color: #ffffff;
  .title {
    padding-left: 24px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .phone-content {
    padding: 16px;
    .form-content {
      width: 676px;
      margin: 16px auto;
      .verification {
        position: relative;
      }
      .btn-code,
      .btn-timer {
        cursor: pointer;
        position: absolute;
        right: 0;
        width: 92px;
        height: 40px;
        border: 1px solid #dedede;
        text-align: center;
        line-height: 40px;
        color: #1e8dff;
        background-color: #ffffff;
      }
      .btn-timer {
        color: #1e8dff;
        background: #f7f7f7;
      }
    }
  }
}
</style>
